import React, { useEffect } from 'react';
import { Link ,  useNavigate, useSearchParams} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../loginSlice';
import "./login.css";
import { setBackButtonUrl } from '../uiSlice';
import Swal from "sweetalert2";

function Login() {
  const dispatch = useDispatch();
  const { status, user, error } = useSelector(state => state.auth);
  const { status: themeStatus, data: themeData } = useSelector(state => state.theme);

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const isAdmin = searchParams.get('admin') === 'true';


  useEffect(() => {
    dispatch(loginUser());
  }, [dispatch]);


   useEffect(() => {
    if (status === 'succeeded' && user && isAdmin) {
      navigate('/admin');
    }
  }, [status, user, isAdmin, navigate]);

  useEffect(() => {
 
    if (status === 'succeeded' && user.backButtonRedirect) {
        dispatch(setBackButtonUrl(user.backButtonRedirect));
    }
  }, [status, user]);



  if (status === 'loading' || themeStatus === 'loading') {
    return (
      <div className="login-main-container">
      <div className='quiz-loader-container'>
       <div className="quiz-loader"></div>
      </div>
      </div>
    );
  }

  if (status === 'failed') {
      Swal.fire("Session Expired!", error, "error").then(() => {
        window.location.href = user.backButtonRedirect;
      });
  }

  return (
    <div className="login-main-container">
      {themeData && (
        <img
          src={process.env.REACT_APP_S3_PATH + themeData.logo}
          className="login-logo"
          alt="Game Logo"
        />
      )}
      {user && (
        <div>
          <Link to="/rules" className="begin-play-btn">
            BEGIN PLAY
          </Link>
        </div>
      )}
    </div>
  );
}

export default Login;